// extracted by mini-css-extract-plugin
module.exports = {"SubTopicItems":"SubTopicItems_SubTopicItems__2-bUX","Item":"SubTopicItems_Item__3t6h3","Active":"SubTopicItems_Active__2EPl5"};